import { apiClient } from "./api-client";
import type { Product, ProductsResponse } from "../types/product";

export async function fetchProducts(): Promise<ProductsResponse> {
  return apiClient<ProductsResponse>("/admin/products");
}

export interface CreateProductInput {
  name: string;
  price?: number;
  description?: string;
  currency?: string;
  sku?: string;
  is_active?: boolean;
}

export interface UpdateProductInput {
  name?: string;
  price?: number;
  description?: string;
  currency?: string;
  sku?: string;
  is_active?: boolean;
}

export async function createProduct(
  input: CreateProductInput,
): Promise<Product> {
  return apiClient<Product>("/admin/products", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateProduct(
  productId: string,
  input: UpdateProductInput,
): Promise<Product> {
  return apiClient<Product>(`/admin/products/${productId}`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export async function deleteProduct(
  productId: string,
): Promise<{ id: string; deleted: boolean }> {
  return apiClient<{ id: string; deleted: boolean }>(
    `/admin/products/${productId}`,
    {
      method: "DELETE",
    },
  );
}
